module.exports = __webpack_public_path__ + "img/JLK3.png";